import {
  Container,
  Grid,
  makeStyles,
  Paper,
  Typography,
  useMediaQuery,
  useTheme
} from '@material-ui/core';
import { Form, Formik } from 'formik';
import { withSnackbar } from 'notistack';
import React, { useEffect, useRef, useState } from 'react';

import { useHistory } from 'react-router-dom';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom';
import FinalButtons from '../../../FinalButtons';
import FinalButtonsMobile from '../../../FinalButtonsMobile';
import ExportadorService from '../../../services/ExportadorService';
import axios from '../../../utils/axios';
import { Yup } from '../../../utils/form-utils';
import ExportadorForm from './ExportadorForm';
import FormikSubmitEffect from './FormikSubmitEffect';

const useStyles = makeStyles(theme => ({
  container: {
    marginLeft: 0,
    marginRight: 0,
    paddingBottom: theme.spacing(8),
    [theme.breakpoints.down('sm')]: {
      paddingBottom: 0,
      padding: 0
    }
  },
  innerContainer: {
    [theme.breakpoints.down('sm')]: {
      padding: 0
    }
  },
  paper: {
    // marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    padding: theme.spacing(4),
    // marginLeft: theme.spacing(6),
    // marginRight: theme.spacing(6),
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      marginBottom: 0,
      padding: theme.spacing(0),
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(5)
    }
  },
  inputGroup: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  }
}));

const validEmailAddress = 'validation.validEmailAddress';
const validationSchema = Yup.object().shape({
  rucExportador: Yup.string().required(),
  razonSocialExportador: Yup.string().required(),
  ciudadExportador: Yup.string(),
  direccionExpo: Yup.string(),
  codigoPostal: Yup.number()
    .typeError('Solo se permiten números')
    .required(),
  personaContacto: Yup.string().required(),
  telefono: Yup.string().required(),
  emailExpo: Yup.string()
    .email(validEmailAddress)
    .required()
});

const PerfilEditForm = props => {
  const { enqueueSnackbar } = props;
  const {
    params: { id }
  } = useRouteMatch();
  const formik = useRef();
  const classes = useStyles();
  const [loadingSendPre, setLoadingSendPre] = useState(false);
  const history = useHistory();
  const myRef = useRef(null);
  const theme = useTheme();
  const isPhone = useMediaQuery(theme.breakpoints.down('sm'));
  const [baseObject, setBaseObject] = useState({
    rucExportador: '',
    razonSocialExportador: '',
    ciudadExportador: '',
    direccionExpo: '',
    codigoPostal: '',
    personaContacto: '',
    telefono: '',
    emailExpo: ''
  });

  const gridProps = {
    spacing: 3,
    className: classes.inputGroup
  };

  const onSubmitError = () => {
    enqueueSnackbar('Verificar formatos y campos obligatorios', {
      variant: 'warning'
    });
  };

  const enviar = async () => {
    const { values } = formik.current;
    setLoadingSendPre(true);
    try {
      // setTouched({}, false);
      const valuesToSend = Object.assign({}, values);
      valuesToSend.razonSocial = values.razonSocialExportador;
      valuesToSend.ruc = values.rucExportador;
      valuesToSend.direccion = values.direccionExpo;
      valuesToSend.ciudad = values.ciudadExportador;
      valuesToSend.codigoPostal = values.codigoPostal;
      valuesToSend.personaContacto = values.personaContacto;
      valuesToSend.telefono = values.telefono;
      valuesToSend.email = values.emailExpo;
      try {
        await axios.post(`exportador/actualizar`, valuesToSend);
        enqueueSnackbar('Guardado correctamente', { variant: 'success' });
        history.push('/');
      } catch (err) {
        console.log(err);

        enqueueSnackbar(
          err?.response?.data?.message || 'Error al intentar guardar',
          {
            variant: 'error'
          }
        );
      }

      setLoadingSendPre(false);
    } catch (error) {
      console.log(error);
      setLoadingSendPre(false);
    }
  };

  const onSubmit = () => {
    enviar();
  };

  const handleBack = () => {
    history.push('/personas');
  };

  const buttonProps = {
    okText: id ? 'Actualizar' : 'Guardar',
    cancelText: 'Volver',
    handleBack,
    isPhone,
    classes,
    loadingSendPre
  };

  const Buttons = () =>
    isPhone ? (
      <FinalButtonsMobile {...buttonProps} />
    ) : (
      <FinalButtons {...buttonProps} />
    );

  useEffect(() => {
    const loadExportador = async () => {
      try {
        const response = await ExportadorService.getPerfil();
        if (response && response.data) {
          const exportador = { ...response.data };
          const nuevosDatos = {};
          nuevosDatos.razonSocialExportador = exportador.razonSocial;
          nuevosDatos.rucExportador = exportador.ruc;
          nuevosDatos.direccionExpo = exportador.direccion;
          nuevosDatos.ciudadExportador = exportador.ciudad;
          nuevosDatos.codigoPostal = exportador.codigoPostal || '';
          nuevosDatos.personaContacto = exportador.personaContacto || '';
          nuevosDatos.telefono = exportador.telefono || '';
          nuevosDatos.emailExpo = exportador.email || '';

          setBaseObject(prev => ({ ...prev, ...nuevosDatos }));
        }
      } catch (error) {
        console.log(error);
      }
    };
    loadExportador();
  }, []);

  return (
    <div>
      <div className={classes.container}>
        <Paper className={classes.paper} elevation={8}>
          <div ref={myRef} style={{ height: 16 }} />
          <Container maxWidth="md" style={{ marginLeft: 0 }}>
            <div style={{ paddingBottom: 40 }}>
              <Grid container item>
                <Typography variant="h6" gutterBottom>
                  Formulario de modificación del perfil del Exportador
                </Typography>
              </Grid>
              <Formik
                enableReinitialize
                initialValues={baseObject}
                validationSchema={validationSchema}
                innerRef={formik}
                onSubmit={onSubmit}
              >
                {() => (
                  <>
                    <FormikSubmitEffect
                      onSubmitError={onSubmitError}
                      validationSchema={validationSchema}
                    />
                    <Form noValidate>
                      <ExportadorForm gridProps={gridProps} edit={true} />
                      <Buttons />
                    </Form>
                  </>
                )}
              </Formik>
            </div>
          </Container>
        </Paper>
      </div>
    </div>
  );
};

export default withSnackbar(PerfilEditForm);
